/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router';
import {
    object, string, func, shape, array, bool, number, arrayOf,
} from 'prop-types';
import { ducks as checkoutDucks } from '../../../../../../../state/ducks/Checkout';
import { getIsProductFilterZipcodeValid, getWineData } from '../../../../../../../state/ducks/App/App-Selectors';
import { actions as appActions } from '../../../../../../../state/ducks/App';
import { useIntersect } from '../../../../../Page/helpers/pageHelpers';

const {
    common: {
        commonSelectors: {
            getLoaderStatus,
        },
    },
    checkout: { checkoutActions },
} = checkoutDucks;

const styles = ({ palette, typography }) => ({
    buttonWrap: {
        width: '100%',
        boxSizing: 'border-box',
        marginTop: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    addToCartButton: {
        color: palette.white,
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '100%',
        height: '50px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        padding: '7px 24px 5px 24px',
        '&:disabled': {
            backgroundColor: `${palette.cms?.wineVerifyDisable}`,
            color: palette.disableButton,
        },
    },
    addSubscriptionToCartButton: {
        color: palette.white,
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '600',
        width: '255px',
        height: '50px',
        fontSize: '15px',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        '&:disabled': {
            backgroundColor: palette.cms?.wineVerifyDisable,
            color: palette.disableButton,
        },
    },
    cyoAddToCartButton: {
        color: palette.white || '#fff',
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '100%',
        height: '40px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '20px',
        lineHeight: '1.46em',
        padding: '5px 24px 5px 24px',
        '&:disabled': {
            backgroundColor: `${palette.colorDisabled || '#ccc'} !important`,
            color: palette.white || '#fff',
        },
    },
    addtoCartStickToHeader: {
        transition: 'all 0.7s cubic-bezier(0.22, 0.61, 0.36, 1) 0s',
        position: 'fixed',
        top: '2px',
        width: 'calc((100% - 24px) - 80px)',
        left: 'calc((24px + 80px)/2)',
        zIndex: 4,
    },
    addToCartBg: {
        backgroundColor: `${palette.primaryButton}`,
    },
    addToCartButtonFullWidth: {
        color: palette.white,
        backgroundColor: `${palette.primaryButton}`,
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        height: '50px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        padding: '7px 24px 5px 24px',
        '&:disabled': {
            backgroundColor: `${palette.cms?.wineVerifyDisable}`,
            color: palette.primary?.contrastText,
        },
    },
});

const MobileFoodAddToCart = ({
    classes,
    history,
    selectedItemId,
    brandId,
    actionAddToCart,
    partNumber,
    categoryId,
    subscription,
    subscriptionDetails,
    productType,
    totalProductSelected,
    maxComponents,
    fullWidth,
    cyoSelectedComponents,
    disableAddToCart,
    personalizedData,
    isPersonalizable,
    isAddToCartEnabled,
    actionSetAddToCartPosition,
    wineValidation,
    quantity,
    categoryPath,
    categoryName,
    isBandItemSelected,
    handleMobileAgeVerification,
    isMobile,
    hasWine,
    addons,
    isPassportBundleProduct,
    setAddToCartClicked,
    selectedState,
}) => {
    const [addToCartPosition, setAddToCartPosition] = React.useState();
    const handleAddToCart = (productId = null, returnObject = false) => {
        setAddToCartClicked(true);
        if (!selectedState) return null;
        const reqObj = {
            brandCode: brandId,
            productCode: (productId || selectedItemId),
            quantity: Math.floor(Number(quantity)) || 1,
            attributes: [],
        };
        if (subscription?.subscriptionCheckbox
            && subscriptionDetails
            && subscriptionDetails.subscriptionDurationKey
            && subscriptionDetails.subscriptionFrequency
            && subscriptionDetails.subscriptionType) {
            let duration = subscriptionDetails.subscriptionDurationKey;
            if (duration.indexOf('.') > 0) {
                duration = duration.substring(0, duration.indexOf('.'));
            }

            let interval = subscriptionDetails.subscriptionFrequency;
            if (interval.indexOf('.') > 0) {
                interval = interval.substring(0, interval.indexOf('.'));
            }

            reqObj.subscription = {
                duration,
                interval,
                type: subscriptionDetails.subscriptionType,
            };
        }
        if (productType === 'cyo') {
            reqObj.components = cyoSelectedComponents;
        }
        if (addons.length > 0) {
            if (cyoSelectedComponents.length > 0) {
                reqObj.components = [...cyoSelectedComponents, ...addons];
            } else {
                reqObj.components = addons;
            }
        }
        if (isPersonalizable && personalizedData) {
            reqObj.personalization = personalizedData;
        }

        if (productType === 'CLUB' || productType === 'COLLECTION') {
            reqObj.lineItemType  = productType;
        }

        if (returnObject) {
            const enableMinicart = false;
            const personalization = null;
            const isMobileData = true;
            return {
                reqObj,
                history,
                partNumber,
                categoryId,
                categoryName,
                categoryPath,
                enableMinicart, // setting enableMinicart to its default as we dont need it for mobile
                handleMiniCartModalClick: () => {}, // setting handleMiniCartModalClick to its default as we dont need it for mobile
                personalization, // setting personalization to its default as we dont need it for mobile
                isMobileData, // setting isMobile true
            };
        }
        let passportBundle = {};
        if (isPassportBundleProduct?.enable) {
            passportBundle = {
                enable: true,
                passportSku: isPassportBundleProduct?.passportSku,
            };
        }
        actionAddToCart(
            reqObj,
            history,
            partNumber,
            categoryId,
            categoryName,
            categoryPath,
            false, // setting enableMinicart to its default as we dont need it for mobile
            () => { }, // setting handleMiniCartModalClick to its default as we dont need it for mobile
            null, // setting personalization to its default as we dont need it for mobile
            true, // setting isMobile true
            passportBundle,
        );
        return true;
    };
    let conditionalClasses;
    if (fullWidth) {
        conditionalClasses = classes.addToCartButtonFullWidth;
    } else if (!disableAddToCart) {
        conditionalClasses = `${classes.addToCartButton} ${classes.addToCartBg}`;
    } else {
        conditionalClasses = classes.addToCartButton;
    }
    const getAvailabilityAddCart = () => {
        let availability = false;
        if (wineValidation) {
            const keys = Object.keys(wineValidation?.wineAvailability);
            keys.forEach((key) => {
                if (wineValidation?.wineAvailability[key].isProductAvailable) {
                    availability = true;
                }
            });
        }
        return availability;
    };
    const isAddToCartDisabled = ((disableAddToCart || (!isAddToCartEnabled && !getAvailabilityAddCart())) && !isMobile);
    let node; let intersectValues;
    // custom hook for the intersection of two add to cart button and header
    if (typeof window !== 'undefined') {
        [node, intersectValues] = useIntersect({ rootMargin: '-10% 0px 0px 0px' });
    }

    // setting the postition to state
    useEffect(() => {
        if (intersectValues.intersectionRect?.top > intersectValues.boundingClientRect?.top) {
            setAddToCartPosition(() => true);
            actionSetAddToCartPosition('fixed');
        } else if (intersectValues.intersectionRect?.top === intersectValues.boundingClientRect?.top) {
            setAddToCartPosition(() => false);
            actionSetAddToCartPosition('static');
        }
    }, [intersectValues]);

    const style = {};
    if (fullWidth && !addToCartPosition) {
        style.width = '100%';
    }

    let layout = (
        <div className={`add-to-cart-container ${classes.buttonWrap}`} id="contAddToCartBtn" ref={node}>
            <Button
                style={style}
                id="pwaAddToCartBtn"
                disabled={isAddToCartDisabled}
                onClick={() => {
                    if (!getAvailabilityAddCart() && isMobile && hasWine) {
                        handleMobileAgeVerification(true, handleAddToCart(null, true));
                        return;
                    }
                    handleAddToCart();
                }}
                className={`${conditionalClasses} ${addToCartPosition ? classes.addtoCartStickToHeader : ''}`}
                variant="contained"
            >
                Add to cart
            </Button>
        </div>
    );
    if (productType === 'cyo') {
        const disabledCYOAddToCart = totalProductSelected === 0 || (totalProductSelected !== maxComponents) || !isBandItemSelected;
        layout = (
            <div className={classes.buttonWrap} id="contAddToCartBtn" ref={node}>
                <Button
                    id="pwaAddToCartBtn"
                    onClick={() => {
                        if (!getAvailabilityAddCart() && isMobile && hasWine) {
                            handleMobileAgeVerification(true, handleAddToCart(null, true));
                            return;
                        }
                        handleAddToCart();
                    }}
                    className={`${disabledCYOAddToCart ? classes.cyoAddToCartButton : `${classes.cyoAddToCartButton} ${classes.addToCartBg}`}
                    ${addToCartPosition ? classes.addtoCartStickToHeader : ''}`}
                    variant="contained"
                    disabled={disabledCYOAddToCart}
                >
                    {totalProductSelected !== 0 && totalProductSelected === maxComponents && isBandItemSelected
                        ? 'Add to cart'
                        : `Select ${!isBandItemSelected ? 'Band' : `${maxComponents} Items`}`}
                </Button>
            </div>
        );
    }
    // const cartPositionRef = React.useRef(addToCartPosition);

    return (
        <>
            {layout}
        </>
    );
};

MobileFoodAddToCart.propTypes = {
    classes: object.isRequired,
    history: object.isRequired,
    categoryId: string.isRequired,
    partNumber: string.isRequired,
    selectedItemId: string,
    brandId: string.isRequired,
    actionAddToCart: func.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
        subscriptionDurationKey: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
        subscriptionCheckbox: bool,
    }),
    productType: string,
    totalProductSelected: number,
    maxComponents: number,
    fullWidth: bool,
    cyoSelectedComponents: array,
    disableAddToCart: bool,
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),
    isPersonalizable: bool,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
    isAddToCartEnabled: bool.isRequired,
    categoryPath: string,
    categoryName: string,
    actionSetAddToCartPosition: func.isRequired,
    isBandItemSelected: bool.isRequired,
    handleMobileAgeVerification: func,
    isMobile: bool,
    hasWine: bool,
    addons: arrayOf(shape({
        brandCode: string,
        productCode: number,
        componentType: string,
        productId: string,
        quantity: number,
    })),
    quantity: string,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    setAddToCartClicked: func,
    selectedState: func,
};

MobileFoodAddToCart.defaultProps = {
    selectedItemId: null,
    productType: '',
    totalProductSelected: 0,
    maxComponents: null,
    fullWidth: false,
    cyoSelectedComponents: [],
    subscriptionDetails: {},
    subscription: {},
    disableAddToCart: false,
    personalizedData: {},
    isPersonalizable: false,
    categoryPath: '',
    categoryName: '',
    wineValidation: null,
    handleMobileAgeVerification: () => { },
    isMobile: false,
    quantity: '1',
    hasWine: false,
    addons: [],
    isPassportBundleProduct: {},
    setAddToCartClicked: () => { },
    selectedState: () => { },
};

const mapStateToProps = (state) => ({
    zipValid: getIsProductFilterZipcodeValid(state),
    wineValidation: getWineData(state),
    showLoadingMessage: getLoaderStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionAddToCart: bindActionCreators(checkoutActions.addToCartFood, dispatch),
    actionSetAddToCartPosition: bindActionCreators(appActions.setAddtoCartPosition, dispatch),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MobileFoodAddToCart)),
);
